var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal custom-modal fade",
      attrs: { id: "report_form", role: "dialog" }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-centered modal-lg",
          attrs: { role: "document" }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h5", { staticClass: "modal-title" }, [
                _vm._v("Laporan Summary")
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  ref: "dismisModal",
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-dismiss": "modal",
                    "aria-label": "Close"
                  }
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v("×")
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c(
                    "div",
                    {
                      staticClass: "row",
                      staticStyle: { "margin-bottom": "20px" }
                    },
                    [
                      _c("div", { staticClass: "col-md-12" }, [
                        _c("div", [
                          _vm._v(
                            "Brand : " + _vm._s(_vm.brands ? _vm.brands : "-")
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "Tanggal : " +
                              _vm._s(
                                _vm.formData.date ? _vm.formData.date : "-"
                              )
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-12" }, [
                      _c(
                        "div",
                        { staticClass: "table-responsive table-wrapper" },
                        [
                          _c(
                            "table",
                            {
                              staticClass:
                                "table table-striped custom-table mb-0"
                            },
                            [
                              _vm._m(0),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                [
                                  _vm.loading
                                    ? [
                                        _c("tr", [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "7" } },
                                            [
                                              _c("Skeleton", {
                                                attrs: { count: 1 }
                                              })
                                            ],
                                            1
                                          )
                                        ])
                                      ]
                                    : [
                                        _c("tr", [
                                          _c(
                                            "td",
                                            { staticClass: "text-wrap" },
                                            _vm._l(_vm.rows.shopee, function(
                                              row,
                                              index
                                            ) {
                                              return _c("div", { key: index }, [
                                                index == "new_link"
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "New Link = " +
                                                          _vm._s(row)
                                                      )
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                index == "open_link"
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "Open Link = " +
                                                          _vm._s(row)
                                                      )
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                index == "close_link"
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "Close Link = " +
                                                          _vm._s(row)
                                                      )
                                                    ])
                                                  : _vm._e()
                                              ])
                                            }),
                                            0
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-wrap" },
                                            _vm._l(_vm.rows.tokopedia, function(
                                              row,
                                              index
                                            ) {
                                              return _c("div", { key: index }, [
                                                index == "new_link"
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "New Link = " +
                                                          _vm._s(row)
                                                      )
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                index == "open_link"
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "Open Link = " +
                                                          _vm._s(row)
                                                      )
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                index == "close_link"
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "Close Link = " +
                                                          _vm._s(row)
                                                      )
                                                    ])
                                                  : _vm._e()
                                              ])
                                            }),
                                            0
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-wrap" },
                                            _vm._l(_vm.rows.lazada, function(
                                              row,
                                              index
                                            ) {
                                              return _c("div", { key: index }, [
                                                index == "new_link"
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "New Link = " +
                                                          _vm._s(row)
                                                      )
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                index == "open_link"
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "Open Link = " +
                                                          _vm._s(row)
                                                      )
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                index == "close_link"
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "Close Link = " +
                                                          _vm._s(row)
                                                      )
                                                    ])
                                                  : _vm._e()
                                              ])
                                            }),
                                            0
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-wrap" },
                                            _vm._l(_vm.rows.bukalapak, function(
                                              row,
                                              index
                                            ) {
                                              return _c("div", { key: index }, [
                                                index == "new_link"
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "New Link = " +
                                                          _vm._s(row)
                                                      )
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                index == "open_link"
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "Open Link = " +
                                                          _vm._s(row)
                                                      )
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                index == "close_link"
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "Close Link = " +
                                                          _vm._s(row)
                                                      )
                                                    ])
                                                  : _vm._e()
                                              ])
                                            }),
                                            0
                                          )
                                        ])
                                      ]
                                ],
                                2
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-center" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-md btn-warning",
                        staticStyle: {
                          "margin-top": "20px",
                          color: "rgb(255, 255, 255)",
                          "background-color": "rgb(255, 155, 68)",
                          "border-color": "rgb(255, 155, 68)"
                        },
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.copySummary($event)
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "la la-clipboard" }),
                        _vm._v(" Copy\n              ")
                      ]
                    ),
                    _vm._v(" "),
                    _vm.whatsapp_number && _vm.whatsapp_number != 0
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-md btn-success",
                            staticStyle: { "margin-top": "20px" },
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.sentSummary($event)
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "fa fa-whatsapp" }),
                            _vm._v(" Sent\n              ")
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.whatsapp_group_number
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-md btn-success",
                            staticStyle: { "margin-top": "20px" },
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.sentGroupSummary($event)
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "fa fa-whatsapp" }),
                            _vm._v(" Sent Group\n              ")
                          ]
                        )
                      : _vm._e()
                  ])
                ])
              ])
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Shopee")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tokopedia")]),
        _vm._v(" "),
        _c("th", [_vm._v("Lazada")]),
        _vm._v(" "),
        _c("th", [_vm._v("Bukalapak")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c(
          "div",
          {
            staticClass: "alert alert-warning",
            staticStyle: { "margin-bottom": "20px", "margin-top": "20px" }
          },
          [
            _c("ul", { staticStyle: { "margin-bottom": "0" } }, [
              _c("li", [
                _vm._v("\n                      New Link = Status "),
                _c("b", [_vm._v("process")]),
                _vm._v(
                  " sama dengan tanggal\n                      yang dipilih\n                    "
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v("\n                      Open Link = Status "),
                _c("b", [_vm._v("process")]),
                _vm._v(
                  " di bulan yang sama,\n                      kecuali tanggal yang dipilih\n                    "
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v("\n                      Close Link = Status "),
                _c("b", [_vm._v("closed")]),
                _vm._v(" di bulan yang sama\n                    ")
              ])
            ])
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f3a6184", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f3a6184","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/monitoring/summary/components/reportAgent.vue
// module id = null
// module chunks = 